export default class FundType {
	public codcuenta: string = "";
	public valor: string = "";
	public tipofondo: string = "";
	public emailusuario: string = "";
	public emailservidor: string = "";
	public codmoneda: string = "";
	public codecelular: string = "";
	public balancexmail: string = "";
	public diabalancexmail: string = "";
	public balancexcelular: string = "";
	public celular: string = "";
	public tipenvio: string = "";
}
